import classNames from 'classnames';
import React from 'react';
import type { Colors } from '../../constants';
import type {
  TypographyFontFamily,
  TypographyFontSize,
  TypographyFontWeight,
  TypographyLetterSpacing,
  TypographyLineHeight,
  TypographyTagName,
  TypographyTextAlign,
  TypographyVerticalTextAlign,
} from './types';

export interface TypographyProps {
  label: string | number | React.ReactNode;
  fontFamily?: TypographyFontFamily;
  fontSize?: TypographyFontSize;
  fontWeight?: TypographyFontWeight;
  letterSpacing?: TypographyLetterSpacing;
  lineHeight?: TypographyLineHeight;
  color?: Colors;
  tagName?: TypographyTagName;
  textAlign?: TypographyTextAlign;
  verticalTextAlign?: TypographyVerticalTextAlign;
  uppercase?: boolean;
  ellipsis?: boolean;
  underline?: boolean;
  role?: React.AriaRole;
  newLineBreak?: boolean;
}

export const Typography = ({
  label: children,
  tagName = 'span',
  fontFamily = 'font-ds-inter',
  fontSize = 'text-ds-400',
  fontWeight = 'font-ds-normal',
  letterSpacing = 'tracking-ds-normal',
  lineHeight = 'leading-ds-300',
  color = 'text-ds-primary',
  textAlign,
  verticalTextAlign,
  uppercase,
  ellipsis,
  underline,
  role,
  newLineBreak,
}: TypographyProps) => {
  return React.createElement(
    tagName,
    {
      className: classNames(
        color,
        fontFamily,
        fontSize,
        fontWeight,
        letterSpacing,
        lineHeight,
        textAlign,
        verticalTextAlign,
        {
          uppercase,
          underline,
          truncate: ellipsis,
          'whitespace-pre-line': newLineBreak,
        }
      ),
      role,
    },
    children
  );
};
